export const FETCH_PRODUCTS = 'fetchProducts'
export const SEARCH_PRODUCTS = 'searchProducts'
